import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CHAT_FEATURE_KEY, State } from '../reducers/chat.reducer';

export const getChatState = createFeatureSelector<State>(CHAT_FEATURE_KEY);

export const getChatMessages = createSelector(getChatState, (state) => state.messages);

export const getChatIsLoading = createSelector(getChatState, (state) => state.isLoading);

export const getChatIsSubmitting = createSelector(getChatState, (state) => state.isSubmitting);

export const getChatError = createSelector(getChatState, (state) => state.error);
